import React, { memo } from "react"
import { useDisclosure } from "@chakra-ui/react"

import { ProductGiftcardBalanceForm } from "./ProductGiftcardBalanceForm"
import { ProductGiftcardBalanceToggle } from "./ProductGiftcardBalanceToggle"

export const ProductGiftcardBalance: React.FC = memo(() => {
  const { isOpen, onToggle } = useDisclosure()

  return (
    <>
      <ProductGiftcardBalanceToggle handleToggle={onToggle} />
      <ProductGiftcardBalanceForm isOpen={isOpen} handleToggle={onToggle} />
    </>
  )
})
